var _desc, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "21px",
    height: "21px",
    viewBox: "0 0 21 21",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Combined Shape") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Final",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Modules",
    transform: "translate(-482.000000, -14020.000000)",
    fill: "#012169"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-22",
    transform: "translate(170.000000, 13949.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-20",
    transform: "translate(25.000000, 55.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M296.384776,25.3847763 L296.384776,13.3847763 L298.384776,13.3847763 L298.384776,25.3847763 L310.384776,25.3847763 L310.384776,27.3847763 L298.384776,27.3847763 L298.384776,39.3847763 L296.384776,39.3847763 L296.384776,27.3847763 L284.384776,27.3847763 L284.384776,25.3847763 L296.384776,25.3847763 Z",
    id: "Combined-Shape",
    transform: "translate(297.384776, 26.384776) rotate(-315.000000) translate(-297.384776, -26.384776) "
  })))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconClose);
export default __webpack_public_path__ + "static/media/icon-close.356e897d976adb73c34fe0d7828650c8.svg";
export { ForwardRef as ReactComponent };